(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    /* CO: Save for later button click handler */
  document.addEventListener('click', async function(e) {
    const saveBtn = e.target.closest('[data-save-for-later]');
    if (!saveBtn) return;

    e.preventDefault();

    /* Prevent double clicks */
    if (saveBtn.classList.contains('is-saving')) return;
    saveBtn.classList.add('is-saving');

    /* Gather cart item data */
    const cartItem = {
      variant_id: saveBtn.dataset.variantId,
      product_id: saveBtn.dataset.productId,
      product_title: saveBtn.dataset.productTitle,
      variant_title: saveBtn.dataset.variantTitle,
      price: parseInt(saveBtn.dataset.price, 10),
      compare_at_price: saveBtn.dataset.compareAtPrice ? parseInt(saveBtn.dataset.compareAtPrice, 10) : null,
      image: saveBtn.dataset.image,
      url: saveBtn.dataset.url,
      key: saveBtn.dataset.lineKey
    };

    try {
      /* Check if COSaveForLater module is loaded */
      if (typeof window.COSaveForLater === 'undefined') {
        console.error('[CO Cart] Save for later module not loaded');
        saveBtn.classList.remove('is-saving');
        return;
      }

      /* Save the item (this removes from cart and adds to saved) */
      await window.COSaveForLater.saveFromCart(cartItem);

      /* Item saved successfully - cart will update via dispatched event */
      console.log('[CO Cart] Item saved for later:', cartItem.product_title);

    } catch (error) {
      console.error('[CO Cart] Error saving item:', error);
      saveBtn.classList.remove('is-saving');
      /* Could show error notification here */
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-saved-items"] && !Shopify.designMode) return;
  try {
    /* CO: Saved Items UI Controller */
  (function() {
    const container = document.getElementById('co-saved-items');
    const listEl = container?.querySelector('[data-saved-items-list]');
    const countEl = container?.querySelector('[data-saved-count]');
    const template = document.getElementById('co-saved-item-template');

    if (!container || !listEl || !template || typeof window.COSaveForLater === 'undefined') {
      console.warn('[CO SavedItems] Required elements or module not found');
      return;
    }

    const wishlist = window.COSaveForLater;

    /* Format price in cents to currency string */
    function formatPrice(cents) {
      const amount = (cents / 100).toFixed(2);
      return window.Shopify?.currency?.active
        ? `${window.Shopify.currency.active} ${amount}`
        : `$${amount}`;
    }

    /* Create a saved item element from template */
    function createItemElement(item) {
      const clone = template.content.cloneNode(true);
      const el = clone.querySelector('.co-saved-item');

      el.dataset.variantId = item.variantId;

      /* Image */
      const img = el.querySelector('[data-item-image]');
      if (img && item.image) {
        img.src = item.image;
        img.alt = item.productTitle;
      }

      /* URLs */
      el.querySelectorAll('[data-item-url]').forEach(link => {
        link.href = item.url;
      });

      /* Title */
      const titleEl = el.querySelector('[data-item-title]');
      if (titleEl) titleEl.textContent = item.productTitle;

      /* Variant */
      const variantEl = el.querySelector('[data-item-variant]');
      if (variantEl) {
        if (item.variantTitle && item.variantTitle !== 'Default Title') {
          variantEl.textContent = item.variantTitle;
        } else {
          variantEl.style.display = 'none';
        }
      }

      /* Price */
      const priceEl = el.querySelector('[data-item-price]');
      if (priceEl) priceEl.textContent = formatPrice(item.price);

      return el;
    }

    /* Render all saved items */
    function render() {
      const items = wishlist.getAll();
      const count = items.length;

      /* Update count */
      if (countEl) countEl.textContent = `(${count})`;

      /* Show/hide container */
      container.style.display = count > 0 ? '' : 'none';

      /* Clear and re-render items */
      listEl.innerHTML = '';
      items.forEach(item => {
        const el = createItemElement(item);
        listEl.appendChild(el);
      });
    }

    /* Handle move to cart */
    async function handleMoveToCart(e) {
      const btn = e.target.closest('[data-move-to-cart]');
      if (!btn) return;

      const itemEl = btn.closest('.co-saved-item');
      if (!itemEl) return;

      const variantId = itemEl.dataset.variantId;
      if (!variantId) return;

      itemEl.classList.add('is-loading');

      try {
        await wishlist.moveToCart(variantId);
        /* Re-render will happen via event listener */
      } catch (error) {
        console.error('[CO SavedItems] Error moving to cart:', error);
        itemEl.classList.remove('is-loading');
        /* Could show error notification */
      }
    }

    /* Handle remove from saved */
    function handleRemove(e) {
      const btn = e.target.closest('[data-remove-saved]');
      if (!btn) return;

      const itemEl = btn.closest('.co-saved-item');
      if (!itemEl) return;

      const variantId = itemEl.dataset.variantId;
      if (!variantId) return;

      wishlist.remove(variantId);
      /* Re-render will happen via event listener */
    }

    /* Event listeners */
    listEl.addEventListener('click', function(e) {
      handleMoveToCart(e);
      handleRemove(e);
    });

    /* Listen for wishlist changes */
    wishlist.subscribe(function(event, data) {
      render();
    });

    /* Also listen for custom events */
    document.addEventListener('co:wishlist:add', render);
    document.addEventListener('co:wishlist:remove', render);
    document.addEventListener('co:wishlist:clear', render);

    /* Initial render */
    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
